export type AdjustmentRelatedField = 'deductible' | 'coinsurance' | 'copay' | 'insuranceAdjustments' | 'autoWriteOff' | 'nonCovered';

export const adjustmentRelatedFields: readonly AdjustmentRelatedField[] = [
  'deductible',
  'coinsurance',
  'copay',
  'insuranceAdjustments',
  'autoWriteOff',
  'nonCovered',
];

export type AdjustmentBucketStyle = {
  backgroundClassName: string;
  borderClassName: string;
  textClassName: string;
  amountTextClassName: string;
};

type AdjustmentRelatedInfo = {
  groupCode: string;
  reasonCode: string;
};

const defaultAdjustmentBucketStyle: AdjustmentBucketStyle = Object.freeze({
  backgroundClassName: 'bg-slate-50',
  borderClassName: 'border-slate-200',
  textClassName: 'text-slate-800',
  amountTextClassName: 'text-slate-500',
});

export const adjustmentBucketStyles: Readonly<
Record<AdjustmentRelatedField, AdjustmentBucketStyle>
> = Object.freeze({
  copay: {
    backgroundClassName: '!bg-sky-50',
    borderClassName: '!border-sky-200',
    textClassName: 'text-sky-700',
    amountTextClassName: 'text-sky-700',
  },

  coinsurance: {
    backgroundClassName: '!bg-sky-50',
    borderClassName: '!border-sky-200',
    textClassName: 'text-sky-700',
    amountTextClassName: 'text-sky-700',
  },

  deductible: {
    backgroundClassName: '!bg-sky-50',
    borderClassName: '!border-sky-200',
    textClassName: 'text-sky-700',
    amountTextClassName: 'text-sky-700',
  },

  nonCovered: {
    backgroundClassName: '!bg-sky-50',
    borderClassName: '!border-sky-200',
    textClassName: 'text-sky-700',
    amountTextClassName: 'text-sky-700',
  },

  insuranceAdjustments: {
    backgroundClassName: '!bg-yellow-50',
    borderClassName: '!border-yellow-200',
    textClassName: 'text-yellow-700',
    amountTextClassName: 'text-yellow-700',
  },

  autoWriteOff: {
    backgroundClassName: '!bg-orange-50',
    borderClassName: '!border-orange-200',
    textClassName: 'text-orange-700',
    amountTextClassName: 'text-orange-700',
  },

});

export function getAdjustmentBucketStyle(
  field?: AdjustmentRelatedField | null,
): AdjustmentBucketStyle {
  if (!field) {
    return defaultAdjustmentBucketStyle;
  }

  return adjustmentBucketStyles[field] ?? defaultAdjustmentBucketStyle;
}

export const adjustmentCodesByField: Readonly<
Partial<Record<AdjustmentRelatedField, AdjustmentRelatedInfo>>
> = Object.freeze({
  deductible: {
    groupCode: 'PR',
    reasonCode: '1',
  },
  coinsurance: {
    groupCode: 'PR',
    reasonCode: '2',
  },
  copay: {
    groupCode: 'PR',
    reasonCode: '3',
  },
});

export const adjustmentNonMappingFields = [
  'nonCovered',
  'insuranceAdjustments',
  'autoWriteOff',
] as const satisfies readonly AdjustmentRelatedField[];

export const readonlyAdjustmentTotalFields = [
  'insuranceAdjustments',
  'autoWriteOff',
] as const satisfies readonly AdjustmentRelatedField[];

export const adjustmentTargetMoveRules: Readonly<Partial<Record<
  AdjustmentRelatedField,
  readonly AdjustmentRelatedField[]
>>> = Object.freeze({
  insuranceAdjustments: ['autoWriteOff'],
});
